import Loader from "components/Loader/Loader";
import DateSelector from "Dashboard/components/DateSelector";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getFinancialStatistics,
  selectState,
} from "../slices/FinancialStatistics.slice";
import { selectState as mainSelectState } from "../slices/main.slice";
import { FormatNumber, mapProjectCategories } from "../services/statistics.service";
import { FormatDate } from "utils/dateUtils";

export const NonProjectsStatistics = () => {
  const { statistics, loading } = useSelector(selectState);

  const { mainDateFrom } = useSelector(mainSelectState);

  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [, setDateTo] = useState<Date | null>(null);
  const dispatch = useAppDispatch();
  const [projectsArray, setProjectsArray] = useState<number[]>([]);

  useEffect(() => {
    if (dateFrom != null) {
      dispatch(
        getFinancialStatistics({
          year: dateFrom.getFullYear(),
          projectIds: projectsArray,
        })
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFrom, projectsArray]);

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  const getHighest = () => {
    let highest = 0;
    const array = [
      statistics?.administrationCosts,
      statistics?.bonuses,
      statistics?.contributions,
      statistics?.taxes,
      statistics?.insurance,
      statistics?.personalExpenses,
      statistics?.donations,
      statistics?.other,
    ];
    array.forEach((element) => {
      if (element && Math.abs(element) > highest) {
        highest = Math.abs(element);
      }
    });
    return highest;
  };

  const getHeight = (num: number | undefined) => {
    if (num === 0) {
      return 0;
    }
    if (num) {
      const result = Math.abs(100 / (getHighest() / num));
      return Math.round(result);
    }
  };

  const pushToArray = (index: number) => {
    let newProjectsArray: number[];
    if (projectsArray.includes(index)) {
      newProjectsArray = projectsArray.filter((element) => element !== index);
    } else {
      newProjectsArray = [...projectsArray, index];
    }
    setProjectsArray(newProjectsArray);
  };

  return (
    <div className="mainDiv">
      <div className="header red">Fiksni troškovi firme van projekata</div>
      <div className="graphs loading-container">
        {loading && <Loader />}
        <div className="graphs-header">
          <span>
            <div className="color7"></div>Plate administracije
          </span>
          <span>
            <div className="color8"></div>Bonusi
          </span>
          <span>
            <div className="color9"></div>Doprinosi
          </span>
          <span>
            <div className="color10"></div>Porez
          </span>
          <span>
            <div className="color11"></div>Osiguranje
          </span>
          <span>
            <div className="color12"></div>Troškovi lično
          </span>
          <span>
            <div className="color13"></div>Donacije
          </span>
          <span>
            <div className="color6"></div>Ostalo
          </span>
        </div>
        <div className="graphs-content">
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.administrationCosts
            )}`}
          >
            <div className="color7"></div>
            <p>{FormatNumber(statistics?.administrationCosts)} rsd</p>
          </span>
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.bonuses
            )}`}
          >
            <div className="color8"></div>
            <p>{FormatNumber(statistics?.bonuses)} rsd</p>
          </span>
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.contributions
            )}`}
          >
            <div className="color9"></div>
            <p>{FormatNumber(statistics?.contributions)} rsd</p>
          </span>
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.taxes
            )}`}
          >
            <div className="color10"></div>
            <p>{FormatNumber(statistics?.taxes)} rsd</p>
          </span>
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.insurance
            )}`}
          >
            <div className="color11"></div>
            <p>{FormatNumber(statistics?.insurance)} rsd</p>
          </span>
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.personalExpenses
            )}`}
          >
            <div className="color12"></div>
            <p>{FormatNumber(statistics?.personalExpenses)} rsd</p>
          </span>
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.donations
            )}`}
          >
            <div className="color13"></div>
            <p>{FormatNumber(statistics?.donations)} rsd</p>
          </span>
          <span
            className={`secondGraph secondGraph-${getHeight(
              statistics?.other
            )}`}
          >
            <div className="color6"></div>
            <p>{FormatNumber(statistics?.other)} rsd</p>
          </span>
        </div>
      </div>
      <table className="statistics-table-header">
        <colgroup>
          <col className="w5" />
          <col className="w24" />
          <col className="w11" />
          <col className="w10" />
          <col className="w10" />
          <col className="w10" />
          <col className="w11" />
          <col className="w11" />
        </colgroup>
        <thead>
          <tr>
            <th className="selector">
              <DateSelector
                showMonth={false}
                lastYearNumbers={5}
                selectDate={selectDate}
                selectedYear={mainDateFrom?.getFullYear()}
              />
            </th>
            <th className="header-cell">naziv projekta</th>
            <th className="header-cell">kategorija</th>
            <th>datum ugovora</th>
            <th>početak radova</th>
            <th className="header-cell">krajnji rok</th>
            <th className="header-cell">završio</th>
            <th>isplatili</th>
          </tr>
        </thead>
      </table>
      <table className="statistics-table-content loading-container">
        <colgroup>
          <col className="w5" />
          <col className="w24" />
          <col className="w11" />
          <col className="w10" />
          <col className="w10" />
          <col className="w10" />
          <col className="w11" />
          <col className="w11" />
        </colgroup>
        <tbody>
          {statistics?.projects &&
            statistics?.projects.map((project, index) => (
              <tr key={index}>
                <td className="firstBtn">
                  <div>
                    <input
                      onChange={() => pushToArray(project.projectId)}
                      type="checkbox"
                      checked={projectsArray.includes(project.projectId)}
                    />
                  </div>
                </td>
                <td>
                  <p>{project.projectName}</p>
                </td>
                <td>{mapProjectCategories(project.type.name)}</td>
                <td>{FormatDate(project.contractDate)}</td>
                <td>{FormatDate(project.startDate)}</td>
                <td>{FormatDate(project.finishDate)}</td>
                <td>{FormatDate(project.dueDate)}</td>
                <td>{FormatNumber(project.expenses)} rsd</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
